import axios from 'axios'
import { useContext, useState } from 'react'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, success } from '../../shared/constants'
import urlSearchParams from '../../components/urlSearchParams'
import { useCompanyAdmin } from '../CompanyAdmin/useCompanyAdmin'

export const useLocation = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const [regions, setRegions] = useState([])
  const [zones, setZones] = useState([])
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [city, setCity] = useState([])
  const [areas, setAreas] = useState([])
  const [stores, setStores] = useState([])
  const [done, setDone] = useState(false)
  const [loading, setLoading] = useState(false)

  const getAllRegion = async () => {
    setLoading(true)
    axios
      .get(API.GET_ALL_REGION, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setRegions(data.data)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          // return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAllZone = async (dto) => {
    setLoading(true)
    console.log("zone", "zones")
    //console.log('DTO : ', dto)
    axios
      .post(API.GET_ALL_ZONE, dto, header)
      .then(({ status, data }) => {
        //consolse.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setZones(data.data)
        console.log(data.data)
        return data.data;
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          // return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAllState = async (dto) => {
    setLoading(true)
    //console.log('DTO : ', dto)
    axios
      .post(API.GET_ALL_STATE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setStates(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          // return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAllCity = async (dto) => {
    //console.log('DTO : ', dto)
    setLoading(true)
    axios
      .post(API.GET_ALL_CITY, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setCity(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          // return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAllDistrict = async (dto) => {
    //console.log('DTO : ', dto)
    setLoading(true)
    axios
      .post(API.GET_ALL_DISTRICT, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setDistricts(data.data)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          // return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAllArea = async (dto) => {
    setLoading(true)
    //console.log('DTO : ', dto)
    axios
      .post(API.GET_ALL_AREA, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setAreas(data.data)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          // return toastMessage(err.response.data.error, error)
        }
      })
  }
  const getAllStores = async (dto) => {
    setLoading(true)
    //console.log('DTO : ', dto)
    axios
      .post(API.GET_ALL_STORE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setStores(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          // return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    getAllRegion,
    regions,
    getAllZone,
    zones,
    getAllState,
    states,
    districts,
    getAllDistrict,
    getAllCity,
    city,
    getAllArea,
    areas,
    getAllStores,
    stores,
    loading,
  }
}
